/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * The type of the credential
 * @export
 */
export const CredentialType = {
    PublicKey: 'public-key',
    Password: 'password',
    Totp: 'totp'
} as const;
export type CredentialType = typeof CredentialType[keyof typeof CredentialType];


export function instanceOfCredentialType(value: any): boolean {
    for (const key in CredentialType) {
        if (Object.prototype.hasOwnProperty.call(CredentialType, key)) {
            if (CredentialType[key as keyof typeof CredentialType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CredentialTypeFromJSON(json: any): CredentialType {
    return CredentialTypeFromJSONTyped(json, false);
}

export function CredentialTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CredentialType {
    return json as CredentialType;
}

export function CredentialTypeToJSON(value?: CredentialType | null): any {
    return value as any;
}

export function CredentialTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CredentialType {
    return value as CredentialType;
}

